import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, ValidatorFn, ValidationErrors, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { takeUntil } from 'rxjs/operators';
import { MedicalReviewService } from '../../services/medical-review.service';
import { AdditionalRequirementsModel } from '../../models/additional-requirements.model';
import { DocumentModalComponentContext, DocumentModalComponent } from '../document-modal/document-modal.component';
import { MvdModalService } from '../../../shared/services/modal/mvd-modal.service';
import { BaseComponent } from '../../../shared/base-components/base.component';

@Component({
    selector: 'additional-requirements',
    templateUrl: './additional-requirements.html'
})
export class AdditionalRequirementsComponent extends BaseComponent {
    @Input()
    public customerNumberId: number;
    @Input()
    public incidentTypeId: number;
    @Output()
    public doneSaving: EventEmitter<any> = new EventEmitter<any>();
    public form: UntypedFormGroup;

    constructor(
        public medicalReviewService: MedicalReviewService,
        public formBuilder: UntypedFormBuilder,
        public modalService: MvdModalService,
        public dialogRef: MatDialogRef<AdditionalRequirementsComponent>
    ) {
        super();
        this.form = this.formBuilder.group({
            correctiveLens: [null],
            stateWaiver: [null],
            safetyRegulations: [null],
            providedMec: [null],
            incompleteMec: [null],
            expiredMec: [null],
            additionalInfo: [null],
            additionalInfoText: [null]
        }, {
            validators: this.atLeastOneCheckbox
        });

        this.form.get('additionalInfo').valueChanges
            .pipe(takeUntil(this.componentDestroyed))
            .subscribe(i => {
                if (this.form.get('additionalInfo').value == true) {
                    this.form.get('additionalInfoText').setValidators([Validators.required]);
                    this.form.get('additionalInfoText').enable();
                } else {
                    this.form.get('additionalInfoText').clearValidators();
                    this.form.get('additionalInfoText').disable();
                    this.form.get('additionalInfoText').setValue('');
                }

                this.form.get('additionalInfoText').updateValueAndValidity();
            });

        this.form.get('additionalInfo').setValue(false);
    }

    public ngOnInit(): void {
    }

    public save = (): void => {
        let model = this.getModel();
        this.medicalReviewService.GenerateAdditionalRequirements(this.customerNumberId, model)
            .subscribe(result => {
                // After generating the Additional Requirements document, close the current modal, and open the modal that shows the resulting document.
                let data = new DocumentModalComponentContext(null, result);
                this.modalService.open(DocumentModalComponent, data)
                    .afterOpened()
                    .subscribe(() => this.dialogRef.close());
            },
            error => {
                this.handleValidationResult(error.error);
            });
    };

    public cancel = (): void => {
        this.doneSaving.emit(true);
    };

    private atLeastOneCheckbox: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
        if ((control.get('correctiveLens').value == false || control.get('correctiveLens').value == null) &&
            (control.get('stateWaiver').value == false || control.get('stateWaiver').value == null) &&
            (control.get('safetyRegulations').value == false || control.get('safetyRegulations').value == null) &&
            (control.get('providedMec').value == false || control.get('providedMec').value == null) &&
            (control.get('incompleteMec').value == false || control.get('incompleteMec').value == null) &&
            (control.get('expiredMec').value == false || control.get('expiredMec').value == null) &&
            (control.get('additionalInfo').value == false || control.get('additionalInfo').value == null)
        ) {
            return { nothingChecked: true };
        }

        return null;
    };

    private getModel = (): AdditionalRequirementsModel => {
        let model = new AdditionalRequirementsModel();
        model.incidentTypeId = this.incidentTypeId;
        model.correctiveLens = this.form.get('correctiveLens').value || false;
        model.expiredMec = this.form.get('expiredMec').value || false;
        model.incompleteMec = this.form.get('incompleteMec').value || false;
        model.providedMec = this.form.get('providedMec').value || false;
        model.safteyRegulations = this.form.get('safetyRegulations').value || false;
        model.stateWaiver = this.form.get('stateWaiver').value || false;
        model.additionalInfoText = this.form.get('additionalInfoText').value;

        if ('' == model.additionalInfoText) {
            model.additionalInfoText = '';
            model.additionalInfo = false;
        } else {
            model.additionalInfo = true;
        }

        return model;
    };
}
